import { useIntl } from 'react-intl';

import { DisabledPreferences } from '@xingternal/crate-startpage-logged-out-disabled-preferences';

import { variantC } from './copy';
import {
  StyledDropdownTagContainer,
  StyledDropdownTag,
  HideDesktop,
  HideMobile,
} from './preferences-section.styles';
import type { VariantProps } from './types';

const Items: React.FC<VariantProps> = ({
  onChange,
  preferences,
  onFencedClick,
}) => {
  const { formatMessage } = useIntl();

  return (
    <>
      {variantC.options.map((option) => (
        <StyledDropdownTag
          key={option.preference}
          icon={option.icon}
          menuHeaderCopy={formatMessage({ id: option.header })}
          moreOptionsCopy={formatMessage({ id: option.showMore })}
          onMoreOptionsClick={() =>
            onFencedClick && onFencedClick(option.preference)
          }
          options={option.values.map((value) => ({
            copy: formatMessage({ id: value }),
            value,
          }))}
          onChange={(value) =>
            onChange && onChange({ ...preferences, [option.preference]: value })
          }
          value={preferences?.[option.preference] || ''}>
          {formatMessage({ id: option.copy })}
        </StyledDropdownTag>
      ))}
    </>
  );
};

export const PreferencesSectionVariantC: React.FC<VariantProps> = ({
  preferences,
  onChange,
  onFencedClick,
}) => {
  const { formatMessage } = useIntl();

  const disabledItems = variantC.disabled.items.map((item) => ({
    ...item,
    copy: formatMessage({ id: item.copy }),
  }));

  return (
    <>
      <HideDesktop>
        <Items
          preferences={preferences}
          onChange={onChange}
          onFencedClick={onFencedClick}
        />
        <DisabledPreferences items={disabledItems} onClick={onFencedClick} />
      </HideDesktop>

      <HideMobile>
        <div style={{ display: 'flex', marginBottom: '12px' }}>
          <Items
            preferences={preferences}
            onChange={onChange}
            onFencedClick={onFencedClick}
          />
        </div>

        <StyledDropdownTagContainer>
          <DisabledPreferences items={disabledItems} onClick={onFencedClick} />
        </StyledDropdownTagContainer>
      </HideMobile>
    </>
  );
};
